// extracted by mini-css-extract-plugin
module.exports = {"root":"Tabs_root__pvqQB","tab":"Tabs_tab__3lHbD","tabActive":"Tabs_tabActive__3Z6qD"};